import React from 'react'
import { Modal } from './modal'

type LoginModalProps = {
  isLoginModalOpen: boolean
  setIsLoginModalOpen: (open: boolean) => void
}

const LoginModal = ({ isLoginModalOpen, setIsLoginModalOpen }: LoginModalProps) => (
  <Modal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} title="Login / Signup">
    <p>{/* placeholder for children attribute, which is required */}</p>
    {/* <LoginForm onSuccess={() => setIsLoginModalOpen(false)} /> */}
  </Modal>
)

export default LoginModal
